import { render, staticRenderFns } from "./M2m.vue?vue&type=template&id=31f9cfd2&scoped=true"
import script from "./M2m.vue?vue&type=script&lang=js"
export * from "./M2m.vue?vue&type=script&lang=js"
import style0 from "./M2m.vue?vue&type=style&index=0&id=31f9cfd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f9cfd2",
  null
  
)

export default component.exports